// src/components/kiosk/SuccessIndicator.jsx
import React from 'react';
import Icon from '../../../components/AppIcon';

const SuccessIndicator = ({ 
  action = 'Einstempeln',
  className = ''
}) => {
  const normalize = (value) => value?.toLowerCase()?.replace(/-/g, ' ')?.trim();
  const toGermanAction = (value) => {
    const n = normalize(value);
    if (n === 'clock in') return 'Einstempeln';
    if (n === 'clock out') return 'Ausstempeln';
    if (n === 'break start') return 'Pausenbeginn';
    if (n === 'break end') return 'Pausenende';
    return value || '';
  };
  const displayAction = toGermanAction(action);
  return (
    <div className={`flex flex-col items-center space-y-4 ${className}`}>
      {/* Success Checkmark with Animation */}
      <div className="relative">
        <div className="w-24 h-24 bg-success rounded-full flex items-center justify-center elevation-2 animate-pulse">
          <Icon 
            name="Check" 
            size={48} 
            color="white" 
            strokeWidth={3}
          />
        </div>
        
        {/* Ripple Effect */}
        <div className="absolute inset-0 w-24 h-24 bg-success/20 rounded-full animate-ping"></div>
      </div>

      {/* Success Message */}
      <div className="text-center space-y-2">
        <h2 className="text-3xl font-semibold text-success">
          Erfolgreich!
        </h2>
        <p className="text-xl text-text-primary">
          {displayAction} Erfasst
        </p>
      </div>
    </div>
  );
};

export default SuccessIndicator;